import type { Cents } from "../model/Cents";

export function moneyToCents(money: { amount: string; currency: string }): Cents {
  return Math.round(parseFloat(money.amount) * 100);
}
